import { render } from "./SaidaoDuibiao.vue?vue&type=template&id=b598e146&scoped=true"
import script from "./SaidaoDuibiao.vue?vue&type=script&lang=js"
export * from "./SaidaoDuibiao.vue?vue&type=script&lang=js"

import "./SaidaoDuibiao.vue?vue&type=style&index=0&id=b598e146&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b598e146"]])

export default __exports__